import { WORKFLOW_GRAPH_DENSITIES, WORKFLOW_GRAPH_LAYOUTS, type WorkflowGraphDensity, type WorkflowGraphLayout } from "../../../api/userPreferencesApi";

/** How a Workflow is shown: as a graph, or as nested lists. View state: `?display=list`. */
export type ProcessDisplay = "graph" | "list";

export const PROCESS_DISPLAYS: readonly ProcessDisplay[] = ["graph", "list"];

export const PROCESS_DISPLAY_PARAMETER = "display";

/** Edit mode's old address on the Workflow page (`?mode=edit`): it opens the edit's preparation, by hand (ADR-0031 D2). */
export const PROCESS_MODE_PARAMETER = "mode";
export const EDIT_MODE = "edit";

/** How much the graph's cards show (F76): the view's own choice, `?density=compact`; without
 * it, the user's default from Personal preferences. */
export const PROCESS_DENSITY_PARAMETER = "density";

/** The density a query parameter asks for, or `fallback`, the user's default. */
export function processDensityOf(parameter: string | null, fallback: WorkflowGraphDensity): WorkflowGraphDensity {
  return WORKFLOW_GRAPH_DENSITIES.find((density) => density === parameter) ?? fallback;
}

/** Which way the steps run (F59, as F76): the view's own choice, `?layout=vertical`; without it,
 * the user's default from Personal preferences. */
export const PROCESS_LAYOUT_PARAMETER = "layout";

/** The direction a query parameter asks for, or `fallback`, the user's default. */
export function processLayoutOf(parameter: string | null, fallback: WorkflowGraphLayout): WorkflowGraphLayout {
  return WORKFLOW_GRAPH_LAYOUTS.find((layout) => layout === parameter) ?? fallback;
}

/** The display a query parameter asks for; the graph unless it says `list`. */
export function processDisplayOf(parameter: string | null): ProcessDisplay {
  return parameter === "list" ? "list" : "graph";
}
